import apiProxy from "@shared/utils/api-proxy.ts";
import { AlliancePartnerManagerResponse } from "@shared/services/salesforce/alliancePartnerManager/response.ts";
import { usePartnerStore } from "@shared/stores/partner/partner.ts";

export default async () => {
  const partnerStore = usePartnerStore();
  const alliancePartnerManagerResponse: Record<string, unknown> | null =
    await apiProxy.post(`salesforce/alliancePartnerManager`, {
      crmPartnerId: partnerStore.currentPartnerId,
    });

  if (!alliancePartnerManagerResponse) {
    throw new Error("Got no response from server");
  }

  return alliancePartnerManagerResponse as AlliancePartnerManagerResponse;
};
